<mat-icon class="cb-grey cb-help-cursor" matTooltip="Colour Item"> format_paint </mat-icon>
@if (mappedItem.colourItem.showInClientSpecification) {
    <mat-icon
        class="cb-grey cb-help-cursor"
        aria-hidden="false"
        matTooltip="Included in Flyer / Create Schedule"
    >
        style
    </mat-icon>
}
